import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialModule } from '@app/material.module';
import { LocalDbService } from '@app/core/localDb-service';

import { HttpClientModule } from '@angular/common/http';
import { BlockedInputDirective } from '../_directives/blocked-input.directive';

@NgModule({
  imports: [FlexLayoutModule, MaterialModule, CommonModule, HttpClientModule],
  declarations: [BlockedInputDirective],
  providers: [LocalDbService],
  exports: [],
})
export class SharedModule {}
